(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hotspot-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.addEventListener('DOMContentLoaded', () => {
      const revealWrapper = document.getElementById('hotspot-reveal-wrapper__8b');
  
      const handleInteraction = event => {
        const hotspot = event.target.closest('.hotspot-pointer__8b');
  
        if (hotspot) {
          event.stopPropagation();
          const content = hotspot.querySelector('.reveal-wrapper__8b')?.innerHTML;
  
          if (content) {
            revealWrapper.innerHTML = content;
            revealWrapper.classList.add('active');
          }
        } else if (!revealWrapper.contains(event.target)) {
          revealWrapper.classList.remove('active');
        }
      };
  
      ['click', 'touchstart'].forEach(eventType =>
        document.addEventListener(eventType, handleInteraction)
      );
  
      new Splide('.hotspot-wrapper__8b').mount();

      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', () => {
          new Splide('.hotspot-wrapper__8b').mount();
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
